<template>
  <section class="section">
    <div class="pl-5 pr-5 pb-5">
      <div class="columns">
        <div class="column">

          <div class="d-flex align-center justify-space-between mb-6">
            <div class="card-big-title">Premium optimization reviews</div>

            <div class="field" style="width: 400px; height: 30px;">
              <div class="control">
                <input
                  style="box-shadow: none; padding-top: 4px; padding-bottom: 4px; height: 2.1rem; font-size: 0.9rem;"
                  type="text" class="input" placeholder="Search pages, projects, keywords" v-model="searchText" @input="changeSearchText"
                >
              </div>
            </div>

          </div>

          <div v-if="totalRows > 0">
            <b-table
              class="review-optimizations-table"
              :data="records" :loading="isLoading" :paginated="totalRows > perPage" backend-pagination :total="totalRows"
              :per-page="perPage" :current-page="currentPage" @page-change="onPageChange" backend-sorting
              :default-sort-direction="defaultSortOrder" :default-sort="[sortField, sortOrder]" @sort="onSort">
              <template slot-scope="props">
                <b-table-column field="order_paid_at" label="Date ordered" sortable>{{ props.row.order_paid_at }}</b-table-column>
                <b-table-column field="id" label="Order number" sortable><b>{{ props.row.id }}</b></b-table-column>
                <b-table-column field="id" label="Credits" centered>
                  <b v-if="props.row.credits_used">{{ props.row.credits_used }}</b>
                  <span v-else-if="props.row.credits_used === 0" style="background-color: #34A85333; color: #11A33D; border: 1px solid #11A33D; font-size: 0.8rem; border-radius: 4px; width: 100px; line-height: 1; padding: 2px 25px;">Free</span>
                </b-table-column>
                <b-table-column field="page_run_id" label="Report ID">
                  <router-link :to="`/sites/${ props.row.site.id }/pages/${ props.row.page.id }/pageruns/${ props.row.page_run_id }`" style="color: #0075FF;">
                    #{{ props.row.page_run_id }}
                  </router-link>
                </b-table-column>
                <b-table-column field="site_name" label="Project"><b>{{ props.row?.site?.name }}</b></b-table-column>
                <b-table-column field="page_name" label="Page"><b>{{ props.row?.page?.name }}</b></b-table-column>
                <b-table-column field="keywords" label="Keywords"><b>{{ props.row.keywords }}</b></b-table-column>
                <b-table-column field="fulfillement_status" label="Status" sortable>
                  <span v-if="props.row.fulfillement_status === 'pending'" class="d-flex align-center gap5" style="font-weight: 700; color: var(--v-blackColor-base);">
                    <i class="material-icons">fiber_manual_record</i> Ordered
                  </span>
                  <span v-else-if="props.row.fulfillement_status === 'in_progress'" class="d-flex align-center gap5" style="font-weight: 700; color: #0075FF;">
                    <i class="material-icons">fiber_manual_record</i> In progress
                  </span>
                  <span v-else-if="props.row.fulfillement_status === 'completed'" class="d-flex align-center gap5" style="font-weight: 700; color: #25A97A;">
                    <i class="material-icons">fiber_manual_record</i> Completed
                  </span>
                  <span v-else>
                    {{props.row.fulfillement_status}}
                  </span>
                </b-table-column>
                <b-table-column field="actions" label="Action">
                  <a
                    v-if="props.row.fulfillement_status === 'completed' && props.row.guard_run_status === 'completed'"
                    href="#"
                    style="text-decoration: underline; color: #0075FF; font-weight: 700;"
                    @click.prevent="getPDFReport(props.row.id, 'top_level')"                
                  >Download</a>
                </b-table-column>
              </template>
            </b-table>

            <div class="mt-6" style="max-width: 400px; background-color: var(--v-whiteColor-base); padding: 20px; border: 1px solid var(--v-gray12Color-base); border-radius: 5px;">
              <div class="mb-3" style="color: var(--v-gray2Color-base); font-size: 1rem; font-weight: 700;">Each {{REVIEW_OPTIMIZATION_ORDERS_COUNT_UNTIL_DISCOUNTED_PRICE}}th report is FREE:</div>
              <div class="d-flex justify-space-between" style="padding-bottom: 5px; margin-bottom: 5px; border-bottom: 1px dashed var(--v-gray12Color-base);">
                <div style="color: var(--v-gray2Color-base);">You've ordered</div>
                <div style="color: var(--v-mainColor-base);">{{totalRows}} review{{ totalRows !== 1 ? 's':'' }} in total</div>
              </div>
              <div class="d-flex justify-space-between">
                <div style="color: var(--v-gray2Color-base);">Next free Premium optimization review in:</div>
                <div style="color: var(--v-mainColor-base);">{{remaining_orders_until_discounted_price}} orders</div>
              </div>
            </div>

          </div>
          
          <div
            v-else-if="dataLoadComplete && !searchText.trim()"
            class="review-optimizations-empty"
          >
            <div class="review-optimizations-empty__icon-wrap">
              <i class="material-icons-outlined review-optimizations-empty__icon">article</i>
            </div>
            <div class="review-optimizations-empty__title">No optimization reviews yet</div>
            <p class="review-optimizations-empty__body">
              Optimization Reviews are ordered from a report's Content Brief. Choose a report in this project to get expert recommendations on what to update first.
            </p>
          </div>

          <div v-else class="d-flex align-center justify-center gap15" style="height: 50vh; font-size: 2rem; color: var(--v-gray12Color-base); font-weight: 700;">
            <i class="material-icons-outlined" style="font-size: 3rem;">search</i> No matches found.
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import debounce from "lodash/debounce";

import { mixin } from '@/components/mixin'

import { mixin as exportmixin } from '@/components/export_mixin'
import { toLocalDateString } from '@/utils'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
  downloadFile,
  downloadWordFile,
  downloadEditorReport,
  generateSchemasJSON,
  getReportHeaderImage,
} from "@/utils/download-reports.js"

export default {
  components: { DatePicker },
  mixins: [mixin, exportmixin],
  data () {
    return {
      records: [],
      dates: [moment().subtract(1, 'months').toDate(), moment().toDate()],
      totalRows: 0,
      isLoading: false,
      sortField: 'createdAt',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      currentPage: 1,
      perPage: 15,
      searchText: '',
      searchTimeout: null,

      remaining_orders_until_discounted_price: null,
      REVIEW_OPTIMIZATION_ORDERS_COUNT_UNTIL_DISCOUNTED_PRICE: null,
      dataLoadComplete: false,
    }
  },
  methods: {
    exportRecords(records) {
      const rows = records.map((record) =>
        [
          record.userId,
          record.userEmail,
          record.id,
          record.order_paid_at ? moment.utc(record.order_paid_at).format() : '',
          record.credits_used,
        ].join(',')
      );
      const data = ['User ID,User Email,Order ID,Order Date,Credits used']
        .concat(rows)
        .join('\n');
      const now = new Date();
      const fileName = "ReviewOptimizationOrders_" + now.getUTCFullYear() + "_" + (now.getUTCMonth() + 1) + "_" + now.getUTCDate() + ".csv"
      this.exportToCSV(data, fileName)
    },
    exportPage() {
      this.exportRecords(this.records)
    },
    exportAll() {
      this.$store.commit('showLoading')
      const params = {
        order_status: 'paid',
        include_ai_and_page_run_result: 1,
        paginate: 0,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        filterText: this.searchText
      }
      this.$store.dispatch('getSiteContentAuditOrdersForAdmin', { params })
        .then(response => {
          this.exportRecords(response.data.data)
        })
        .finally(() => {
          this.$store.commit('hideLoading')
        })
    },
    mainPageWordCount(pageRun) {
      const wordCount = pageRun.keywordCounts.rows.find(wc => wc.signal === 'Word Count')
      return wordCount.signalData.targetKeywordCnt
    },
    toLocalDateString(dateStr) {
      return toLocalDateString(dateStr)
    },
    onPerPageChange() {
      this.$nextTick(() => this.loadData())
    },
    onPageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadData()
    },
    onFilter() {
      // console.log('filtering')
      this.$nextTick(() => {
        this.loadData()
      })
    },
    loadData(silent=false) {
      if (!silent) {
        this.isLoading = true
        this.$store.commit('showLoading')
      }

      let startDate = this.dates[0]?moment(this.dates[0]).startOf('day').toDate():null;
      let endDate = this.dates[1]?moment(this.dates[1]).endOf('day').toDate():null;

      let params = {
        user_id: this.ownerUser.id,
        order_status: 'paid',
        include_ai_and_page_run_result: 1,
        paginate: 1,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        page: this.currentPage,
        perPage: this.perPage,
        filterText: this.searchText
      }

      if (startDate) {
        params['startDate'] = startDate.getTime()
      }
      if (endDate) {
        params['endDate'] = endDate.getTime()
      }

      this.$store.dispatch('getReviewOptimizationOrders', params)
        .then(({ data }) => {
          const { total, records, totalPaid } = data
          this.totalRows = total
          this.records = records
          this.totalPaid = totalPaid
        })
        .then(() => {
          return this.$store.dispatch('getReviewOptimizationOrdersPricingInfo')
            .then(response => {
              if (response.data && response.data.status == 'SUCCESS') {
                this.REVIEW_OPTIMIZATION_ORDERS_COUNT_UNTIL_DISCOUNTED_PRICE = response.data.REVIEW_OPTIMIZATION_ORDERS_COUNT_UNTIL_DISCOUNTED_PRICE
                this.remaining_orders_until_discounted_price = response.data.remaining_orders_until_discounted_price
                return Promise.resolve()
              }
            })
        })
        .finally(() => {
          this.dataLoadComplete = true
          if (!silent) {
            this.isLoading = false
            this.$store.commit('hideLoading')
          }
        })
    },
    changeSearchText() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.onFilter();
      }, 1000);
    },
    getPDFReport(order_id, reportType, ommitInstructions = false) {

      const timestamp = moment().format("YYYY_M_D_h_mm_ss");
      this.$store.commit('showLoading');
      this.$store
        .dispatch('getReviewOptimizationOrderPDFReport', { orderId: order_id, reportType: reportType, ommitInstructions })
        .then((response) => {
          const fileName = `${reportType}_${timestamp}`
          downloadFile(response.data, fileName)
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.user
    },
  },
  mounted () {
    this.loadData() 
  },
  destroyed() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
}
</script>

<style lang="scss" scoped>
.review-optimizations-table tbody tr:nth-child(2n) td {
  background: var(--v-pink1Color-base);
}

.review-optimizations-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 50vh;
  padding: 2rem 1rem;
  max-width: 32rem;
  margin-left: auto;
  margin-right: auto;
}

.review-optimizations-empty__icon-wrap {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background-color: #eceff1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.review-optimizations-empty__icon {
  font-size: 2.25rem;
  color: var(--v-gray2Color-base);
}

.review-optimizations-empty__title {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--v-gray2Color-base);
  margin-bottom: 0.75rem;
}

.review-optimizations-empty__body {
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--v-gray2Color-base);
  margin: 0;
}

.review-optimizations-table {
  
  ::v-deep {
    .table {
      border: 1px solid #DADADA;
      border-radius: 5px;
    }
    td, th {
      padding: 18px;
    }
  }

}
</style>
